// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__mXTwS","blok-big-title":"layout_blok-big-title__tOJoU","blok-title":"layout_blok-title__AZjvr","blok-subtitle":"layout_blok-subtitle__hO8gR"};